var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"living-item"},[_c('div',{staticClass:"cover-pic",style:({ backgroundImage: `url(${_vm.item.pictureUrl})` })},[_c('div',{class:[
        'tag',
        _vm.item.playStatus == 2 && 'tag-replay',
        _vm.item.playStatus == 1 && 'tag-living',
      ]},[_vm._v(" "+_vm._s(_vm.item.playStatus == 3 ? "预告" : _vm.item.playStatus == 2 ? "回放" : "直播中")+" ")])]),_c('div',{staticClass:"title text-line-2"},[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('div',{staticClass:"info"},[_vm._v("开播时间："+_vm._s(_vm.item.startDate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }